/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'menu': {
    width: 20,
    height: 21,
    viewBox: '0 0 20 21',
    data: '<path pid="0" d="M18.79 10.641H1c0 3.197 1.761 5.983 4.38 7.5v1.645h9.03v-1.645c2.619-1.517 4.38-4.303 4.38-7.5zM13.625 0c.003 1.912-1.155 1.914-1.152 3.826.002 1.912 1.16 1.91 1.164 3.822M10.133 0c.004 1.912-1.155 1.914-1.152 3.826.003 1.912 1.161 1.91 1.164 3.822M6.642 0c.002 1.912-1.156 1.914-1.153 3.826.003 1.912 1.162 1.91 1.164 3.822" _fill="none" fill-rule="evenodd" _stroke="#606060" stroke-width="1.5"/>'
  }
})
